import { Box, styled } from '@mui/material';

const Toolbar = styled(Box)`
  width: 100%;
  max-height: min-content;
  display: flex;
  align-items: center;
  justify-content: end;

  padding: 0;

  gap: 1rem;
`;

export default Toolbar;
